/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Key_Elegant_Butterfly_ReapInputs */

const fr_key_elegant_butterfly_reap = /** @type {(inputs: Key_Elegant_Butterfly_ReapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

/**

* @param {Key_Elegant_Butterfly_ReapInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const key_elegant_butterfly_reap = /** @type {((inputs?: Key_Elegant_Butterfly_ReapInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Key_Elegant_Butterfly_ReapInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_key_elegant_butterfly_reap(inputs)
});